<app-bottom-sheet #sheet ariaLabel="زمان مجاز معاملات">
	<ng-template #body>
		<div class="flex flex-col gap-2">
			<span class="w-full text-gray-900 font-bold text-center pt-1 text-sm">زمان مجاز معاملات</span>
			<div class="flex flex-col items-start gap-2">
				<span class="rounded-xl p-3 max-w-12 max-h-12 {{ stateStyle().badgeClass }}">
					<ui-icon width="24" height="24" aria-hidden="true" [iconName]="stateStyle().icon" />
				</span>

				<div class="flex flex-col items-start gap-1">
					<p class="text-base font-bold text-gray-900" data-cy="trading-time-headline">{{ headline() }}</p>

					@if (tradingDays()) {
						<div class="flex items-center gap-1 text-xs">
							<ui-icon
								width="20"
								height="20"
								aria-hidden="true"
								class="text-gray-900"
								[iconName]="icons.Calendar" />
							<span class="text-gray-800" data-cy="trading-time-days"
								>روزهای معامله: {{ tradingDays() }}</span
							>
						</div>
					}

					@if (countdown()) {
						<div class="flex items-center gap-1 text-xs">
							<ui-icon
								width="20"
								height="20"
								aria-hidden="true"
								class="text-gray-900"
								[iconName]="icons.Sandglass" />
							<span class="text-gray-800" data-cy="trading-time-countdown">{{ countdownText() }}</span>
						</div>
					}
				</div>
			</div>
			<ui-divider />

			@if (todayTradingPeriods().length > 0) {
				@if (tradingDay(); as day) {
					@if (!day.isToday) {
						<span class="text-xs text-gray-800" data-cy="trading-time-next-day"
							>امروز معاملات انجام نمی‌شود. زمان معاملات روز {{ day.dayLabel }}:</span
						>
					}
				}
				<app-market-time-slicer [periods]="todayTradingPeriods()" [state]="marketState()" />

				<div class="flex flex-col rounded-lg px-3 py-2.5 bg-gray-050 gap-1.5 text-gray-700">
					@for (period of todayTradingPeriods(); track period.type + period.start) {
						@if (period.type === 'preTrading') {
							<div class="flex gap-1 justify-start items-center">
								<ui-icon class="text-yellow-500" width="8" height="8" iconName="circle" />
								<span class="text-xs">
									پیش‌گشایش بازار از ساعت {{ period.start }} تا ساعت
									{{ period.end }}
								</span>
							</div>
						}
						@if (period.type === 'trading') {
							<div class="flex gap-1 justify-start items-center">
								<ui-icon class="text-green-500" width="8" height="8" iconName="circle" />
								<span class="text-xs">
									معاملات پیوسته از ساعت {{ period.start }} تا ساعت
									{{ period.end }}
								</span>
							</div>
						}
					}
				</div>
			}
		</div>
	</ng-template>
	<ng-template #footer>
		<ui-button class="w-full my-3" extraButtonClasses="w-full" variant="mute" size="lg" (clicked)="close()">
			بستن
		</ui-button>
	</ng-template>
</app-bottom-sheet>
